import React, { Component } from "react";

// Styles
import { Timer } from "@learningblocks/storybook-components/lib/ProtocolComponents";

export class Graphics extends Component {

  render() {
    return (
      <Timer
        defaultTimeUpdateRate={50}
        callback={{
          amount: 3600,
          function: (timepassed)=>{
            this.props.interactionProps.heatBlocks[0].slots.forEach((slot)=>{
              if(slot.solutionId){
                this.props.setSolutionIncubated({
                  id: slot.solutionId,
                  incubated: true
                })
              }
            })
          }
        }}
        showPopup={this.props.showPopup}
        running={this.props.running}
        time={this.props.time}
        onClickDone={()=>{
          this.props.setShowPopup({
            id: 1,
            showPopup: false
          })
        }}
        setRunning={(payload)=>this.props.setRunning({
          id: this.props.id,
          running: payload
        })}
        setShowPopup={(payload)=>{
          this.props.setShowPopup({
            id: this.props.id,
            showPopup: payload
          })
        }}
        setTime={(payload)=>this.props.setTime({
          id: this.props.id,
          time: payload
        })}
      />
    );
  }
}
